export enum AppConstants {
    PATH_OF_IMPRESSUM = "/services/file/Impressum_GeoBus.pdf",
}
